import moment from 'moment';
import { PersistentRepo } from '_src/shared/repo';

const transform = res => {
  const getTimezone = PersistentRepo.get('getTimezone');
  const data = res?.data?.info?.studentInfos || [];

  const transformedData = data.map(item => {
    return {
      ...item,
      createdAt: moment
        .tz(
          moment.parseZone(moment(item.createdAt)).format('MM/DD/YYYY HH:mm'),
          'MM/DD/YYYY HH:mm',
          getTimezone
        )
        .format('MM/DD/YYYY HH:mm')
    };
  });

  return { data: transformedData, total: res.data.info.total };
};

export { transform };
